import { useMemo } from "react";
import { useLocation } from "react-router-dom-v5-compat";
import {
  ACTIVITIES_PATH,
  getPackageRoutes,
} from "@b2bportal/core-utilities/overridable";
import { HOTELS_PATH } from "../constants";

const PACKAGES_BASE_ROUTE = getPackageRoutes().BASE_ROUTE;

/**
 * Hook that determines if the current route is a homepage route.
 * Homepage routes are the main landing pages for each funnel:
 * - / (default homepage)
 * - /flights
 * - /cars
 * - /stays
 * - /packages
 * - /activities
 *
 * @returns true if on a homepage route, false otherwise
 */
export const useIsHomepage = (): boolean => {
  const location = useLocation();

  return useMemo(() => {
    const pathname = location.pathname;

    const homepageRoutes = [
      "/",
      "/flights",
      "/cars",
      HOTELS_PATH, // /stays
      PACKAGES_BASE_ROUTE, // /packages
      ACTIVITIES_PATH, // /activities
    ];

    return homepageRoutes.includes(pathname);
  }, [location.pathname]);
};
